import { RbSubAction } from '../../customEnums/RbSubAction';
import { urls } from "../../urls";

const fetchMaintenanceData = async (queryDataRequest: any, action?: RbSubAction | undefined) => {
    const queryUrl = urls.QUERY
    const url: string = `${process.env.NODE_ENV === "production" ? queryUrl : ""}/query`;
    try {
        return await (await fetch(url, {
            method: "POST",
            credentials: "include",
            body: JSON.stringify(queryDataRequest)
        })).json();
    } catch (err: any) {
        console.error('error querying rapback subs: ', err)
        return {
            message: "error",
            status: 400,
            ok: false
        }
    }
}

export default fetchMaintenanceData;